<nz-card class="flow-card" nzTitle="Dish Equipment">
  <p class="flow-card__subtitle">Select the equipment needed for this order and capture any additional receivers.</p>

  <form nz-form [formGroup]="planForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="mainTopBox">Main Top Box</nz-form-label>
      <nz-form-control>
        <nz-select
          id="mainTopBox"
          formControlName="mainTopBox"
          nzPlaceHolder="Main box"
        >
          <nz-option
            *ngFor="let d of devices"
            [nzValue]="d.value"
            [nzLabel]="d.display"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label nzFor="secondaryBox">Secondary Box</nz-form-label>
      <nz-form-control>
        <nz-select
          id="secondaryBox"
          formControlName="secondaryBox"
          nzPlaceHolder="Secondary box"
        >
          <nz-option
            *ngFor="let d of devices2"
            [nzValue]="d.value"
            [nzLabel]="d.display"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <div class="additional-section" *ngIf="additionalBoxes.controls.length">
      <h2 class="additional-section__title">Additional boxes</h2>

      <div formArrayName="additionalBoxes" class="additional-section__list">
        <div *ngFor="let _ of additionalBoxes.controls; let i = index" class="additional-item">
          <nz-form-item class="flow-form__item">
            <nz-form-label>Additional Box #{{ i + 1 }}</nz-form-label>
            <nz-form-control>
              <div class="additional-item__row">
                <nz-select [formControlName]="i" nzPlaceHolder="Additional box">
                  <nz-option
                    *ngFor="let d of devices2"
                    [nzValue]="d.value"
                    [nzLabel]="d.display"
                  ></nz-option>
                </nz-select>
                <button
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nzSize="small"
                  class="additional-item__remove"
                  (click)="removeBox(i)"
                >
                  <span nz-icon nzType="delete"></span>
                </button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>

    <div class="flow-actions" *ngIf="(additionalBoxes?.length ?? 0) < 5">
      <button nz-button nzType="default" nzBlock (click)="addBox()">
        <span nz-icon nzType="plus-circle"></span>
        Add Additional Box
      </button>
    </div>

    <div class="flow-actions flow-actions--trailing">
      <button nz-button nzType="primary" nzBlock [disabled]="planForm.invalid" [nzLoading]="addingEquipment" (click)="submit()">
        Next Step
      </button>
    </div>
  </form>
</nz-card>
